module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "reservation-modal editReservationModal payment dark-top pb-3",
    attrs: {
      "dialog": "modal-wide",
      "customClass": "heightAuto",
      "footer": false
    },
    on: {
      "close": _vm.close
    }
  }, [(_vm.reservation) ? _c('div', {
    ref: "modalTopAnchor",
    staticClass: "pt-3",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('title-area', {
    attrs: {
      "reservation": _vm.reservation
    },
    on: {
      "titleAreaIsReadyToSubmit": function ($event) { return _vm.titleAreaIsReadyToSubmit = $event; }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column bg-lighter position-relative",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.showPrebookOverlay) ? _c('prebook-overlay') : _c('div', [(_vm.showCreateInvoiceModal) ? _c('create-invoice-modal', {
    attrs: {
      "reservation": _vm.reservation
    },
    on: {
      "close": _vm.toggleCreateInvoiceModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showEditExtras) ? _c('edit-extras', {
    attrs: {
      "reservation": _vm.reservation,
      "showAddPayment": _vm.showAddPayment
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showViewExtras) ? _c('view-extras', {
    attrs: {
      "reservation": _vm.reservation,
      "showAddPayment": _vm.showAddPayment
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAddExtras) ? _c('add-extras', {
    attrs: {
      "reservation": _vm.reservation
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showEditTransport) ? _c('edit-transport', {
    attrs: {
      "reservation": _vm.reservation,
      "showAddPayment": _vm.showAddPayment
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showInvoiceModal) ? _c('invoice-modal', {
    attrs: {
      "reservation": _vm.reservation
    },
    on: {
      "toggleInvoiceModal": _vm.toggleInvoiceModal
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isSavingChanges) ? _c('div', {
    staticClass: "unsavedChanges bg-color-1 lightest text-center",
    class: {
      'active': _vm.reservationHasUnsavedChanges
    }
  }, [_vm._v("\n                Don't forget to\n                "), _c('span', {
    staticClass: "bold",
    staticStyle: {
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.handleSaveChanges
    }
  }, [_vm._v("Save Changes")]), _vm._v(".\n            ")]) : _c('div', {
    staticClass: "unsavedChanges bg-color-1 lightest text-center",
    class: {
      'active': _vm.reservationHasUnsavedChanges
    }
  }, [_vm._v("\n                Saving Changes.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [(!_vm.reservation && !_vm.getIsLoadingReservations) ? _c('div', {
    staticClass: "col-sm-10 text-center dark fs-larger p-5"
  }, [_vm._v("\n                    Please wait while we load your reservation.\n                ")]) : _c('div', {
    staticClass: "col-sm-10"
  }, [_c('top-area', {
    staticClass: "mt-2",
    attrs: {
      "reservation": _vm.reservation
    },
    on: {
      "topAreaIsReadyToSubmit": function ($event) { return _vm.topAreaIsReadyToSubmit = $event; }
    }
  }), _vm._v(" "), _c('tabs', {
    staticClass: "reservation-edit__tabs",
    attrs: {
      "options": {
        useUrlFragment: true
      }
    },
    on: {
      "changed": _vm.onTabChanged
    }
  }, [_c('tab', {
    attrs: {
      "name": "Reservation"
    }
  }, [_c('tab-reservation', {
    attrs: {
      "reservation": _vm.reservation,
      "tabClass": _vm.tabWarnings.reservation ? 'warning' : null
    },
    on: {
      "toggleEditPaxReservation": _vm.toggleEditPaxReservation
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Customer",
      "tabClass": _vm.tabWarnings.customer ? 'warning' : null
    }
  }, [_c('tab-customer', {
    attrs: {
      "disabled": _vm.getIsSavingReservation,
      "reservation": _vm.reservation
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Invoices",
      "tabClass": _vm.tabWarnings.invoices ? 'warning' : null
    }
  }, [(_vm.reservation) ? _c('tab-invoices', {
    attrs: {
      "reservation": _vm.reservation
    },
    on: {
      "toggleInvoiceModal": _vm.toggleInvoiceModal
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Payments",
      "tabClass": _vm.tabWarnings.payments ? 'warning' : null
    }
  }, [_c('tab-payments', {
    attrs: {
      "reservation": _vm.reservation,
      "disabled": _vm.getIsSavingReservation
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Logs",
      "tabClass": _vm.tabWarnings.logs ? 'warning' : null
    }
  }, [_c('tab-logs', {
    attrs: {
      "reservation": _vm.reservation,
      "disabled": _vm.getIsSavingReservation
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 pl-0"
  }, [_c('side-buttons', {
    attrs: {
      "disabled": _vm.getIsSavingReservation || _vm.isEditingTabReservation,
      "topAreaIsReadyToSubmit": _vm.topAreaIsReadyToSubmit,
      "titleAreaIsReadyToSubmit": _vm.titleAreaIsReadyToSubmit,
      "reservation": _vm.reservation,
      "showAddPayment": _vm.showAddPayment,
      "isToSaveChanges": _vm.isToSaveChanges
    },
    on: {
      "toggleAddPayment": _vm.toggleAddPayment,
      "updateReservationsList": _vm.reservationUpdated,
      "updateThisReservation": _vm.updateThisReservation,
      "changesSaved": _vm.changesSaved,
      "savingChanges": function ($event) { return _vm.isSavingChanges = $event; }
    }
  })], 1)]), _vm._v(" "), (_vm.showExtraLogsSection) ? _c('div', {
    staticClass: "pl-3 pr-3 pb-3"
  }, [_c('tab-logs', {
    attrs: {
      "reservation": _vm.reservation,
      "disabled": _vm.getIsSavingReservation,
      "isResume": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-start"
  }, [_c('a', {
    staticClass: "reservations__anchor-see-more-logs my-2 fs-small",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToLogs.apply(null, arguments)
      }
    }
  }, [_vm._v("See All Logs")])])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-14cb4f4e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14cb4f4e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2.vue
// module id = 1941
// module chunks = 0